import React from "react";
import PropTypes from "prop-types";
import { FormInput } from "MODULES/shared/components/Forms";

import * as FormTypes from "MODULES/shared/components/Forms/FormTypes";

export default function Description({
  part_number: partNumber,
  description,
  disabled = false
}) {
  const field = {
    ...description.input,
    onChange: e => {
      description.input.onChange(e);
      partNumber.input.onChange(partNumber.input.value);
    }
  };

  return (
    <FormInput
      input={field}
      meta={description.meta}
      label="Description"
      required
      disabled={disabled}
    />
  );
}

const Field = PropTypes.shape({
  input: FormTypes.stringInput.isRequired,
  meta: FormTypes.meta
});

Description.propTypes = {
  part_number: Field.isRequired,
  description: Field.isRequired,
  disabled: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/modules/parts/components/shared/Description.jsx